import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";
import ConfirmDialog from '../../../components/ConfirmDialog';

function FinancialYear() {

  const [showForm, setShowForm] = useState(false);
  const [partyMaster, setPartyMaster] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [sources, setSources] = useState(["Online", "Store"]);
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [newSourceName, setNewSourceName] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [address, setAddress] = useState([]);
  const [coupon, setCoupon] = useState([]);

  const [form, setForm] = useState({
   financial_year: '',
    valid_up_to: '',
    from_date: '',
to_date: '',
      is_locked: 0
   
  })

  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };



  const handleAddClick = () => {
    setShowForm(true);
  };



//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };


const handleInputChange = (e) => {
  const { name, type, value, checked } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? (checked ? 1 : 0) : value
  }));
};



  const handleSubmit = async (e) => {
    e.preventDefault();


    if (isEditMode) {
      const sendData = new FormData();

      sendData.append("financial_year", form. financial_year);
      sendData.append("valid_up_to", form. valid_up_to);
  
      sendData.append("from_date", form.from_date);
      sendData.append("to_date", form.to_date);
      sendData.append("is_locked", form.is_locked);


      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-finanacial-year/${form.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Financial year updated successfully!', 'success');
        setShowForm(false);

        fetchYear();
        setForm({
           financial_year: '',
           valid_up_to: '',
          to_date: '',
          from_date: '',
          is_locked: '',
        })
      } catch (err) {
        showToast('Fail to update year!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    } else {
      const sendData = new FormData();

      sendData.append("financial_year", form.financial_year);
      sendData.append("valid_up_to", form.valid_up_to);
  
      sendData.append("from_date", form.from_date);
      sendData.append("to_date", form.to_date);
      sendData.append("is_locked", form.is_locked);

      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-finanacial-year",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Financial Year Added successfully!', 'success');
        setShowForm(false);
        fetchYear();

        setForm({
           financial_year: '',
           valid_up_to: '',
          to_date: '',
          from_date: '',
          is_locked: '',
        })
      } catch (err) {
        showToast('Fail to add  year!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    }

  };



  const fetchYear = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-year-list");
      setCoupon(res.data);

    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };



  useEffect(() => {
    fetchYear();
  }, []);




  const handleEdit = (form) => {


    setForm({
      id: form.id || '',
       financial_year: form. financial_year || '',
       valid_up_to: form. valid_up_to || '',
      to_date: form.to_date || '',
      from_date: form.from_date || '',
      is_locked: form.is_locked || '',
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


  const filteredData = coupon.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )
  
  
  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Financial Year</h3>



        <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

          <div className="mb-2 w-50 w-md-50 pe-md-2">
            <input
              className="form-control w-100"
              list="datalistOptions"
              placeholder="Search ...."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <button className="btn btn-success" onClick={handleAddClick}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>


        {showForm && (


          <div className='card p-3 mb-3  w-75 mx-auto'>
            <form onSubmit={handleSubmit} >

                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form. financial_year}
    </span>
  </div>
)}

              <hr />

              <div className='row g-3'>

                <div className="col-md-6">
                  <label htmlFor='name' className="form-label fw-medium" > Finanacial Year </label>
                  <input type="text" className="form-control" name="financial_year" placeholder="Enter here..." value={form.financial_year} onChange={handleInputChange} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" > Valid Upto </label>
                  <input type="date" className="form-control" name="valid_up_to" placeholder="Enter here..."
                    value={form.valid_up_to}
                    onChange={handleInputChange}
                 
                  />
                </div>



              



                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >From Date </label>
                  <input type="date" className="form-control" name="from_date" placeholder="Enter here..."
                    value={form.from_date}
                    onChange={handleInputChange}

                  />
                </div>

                   <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >To Date </label>
                  <input type="date" className="form-control" name="to_date" placeholder="Enter here..."
                    value={form.to_date}
                    onChange={handleInputChange}

                  />
                </div>

         <div className="col-md-6">
  <label className="form-label fw-medium">Is Locked</label>

  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      name="is_locked"
      checked={form.is_locked === 1 || form.is_locked === true}
      onChange={handleInputChange}
    />

    <label className="form-check-label">
      Locked
    </label>
  </div>
</div>
                <div className='gap-2 d-flex justify-content-center mt-4'>
                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}
                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);
                    setIsEditMode(false);
                    setForm({
                      type: '',
                      profession: '',
                      type_profession: '',
                      source: ''
                    })
                  }}>
                    Cancel
                  </button>
                </div>

              </div>
            </form>
          </div>
        )}




        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>

            <thead className='table-info'>
              <tr>
                   <th scope='col'>SN</th>
                    <th scope='col'>Action</th>
             
                <th scope='col'>Year</th>
           

            
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((c, index) => (
                  <tr key={index}>
                       <td>{index + 1}</td>
                     <td>
                      <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(c)}><AiOutlineEdit size={18} />

                      </button>
                    </td>
                 
                    <td>{c.financial_year}</td>
                
                  </tr>
                ))) : (
                <tr>
                  <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>




      </div>
    </div>
  )
}

export default FinancialYear